var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "02-Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6e0eb"
    },
    d: "M1 59h62v4H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4v11h62V4zm14 7H7V7h8zm14 0h-8V7h8zm14 0h-8V7h8zm14 0h-8V7h8z",
    style: {
      fill: "#8BC34A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1h2a1 1 0 0 1 1 1v6H9V2a1 1 0 0 1 1-1zM24 1h2a1 1 0 0 1 1 1v6h-4V2a1 1 0 0 1 1-1zM38 1h2a1 1 0 0 1 1 1v6h-4V2a1 1 0 0 1 1-1zM52 1h2a1 1 0 0 1 1 1v6h-4V2a1 1 0 0 1 1-1z",
    style: {
      fill: "#d6e0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb"
    },
    d: "M1 15h62v44H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 6h-1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h-1a1 1 0 0 0-1 1v6h4V5a1 1 0 0 1-1 1zM40 6h-1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h-1a1 1 0 0 0-1 1v6h4V5a1 1 0 0 1-1 1zM26 6h-1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h-1a1 1 0 0 0-1 1v6h4V5a1 1 0 0 1-1 1zM12 6h-1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h-1a1 1 0 0 0-1 1v6h4V5a1 1 0 0 1-1 1z",
    style: {
      fill: "#a8b7d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6e0eb"
    },
    d: "M14 8h1v3h-1zM1 15v44h62v-6H34C19.088 53 7 41.912 7 27V15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8394b2"
    },
    d: "M1 63v-4h62v2H6v1h57v1H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15v44h62v-6H34C19.088 53 7 41.912 7 27V15z",
    style: {
      fill: "#edf4fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC34A"
    },
    d: "M6 31h4v4H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 35h2.236a25.544 25.544 0 0 1-.936-4H6z",
    style: {
      fill: "#8BC34A"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 58H2v-6H0v11a1 1 0 0 0 1 1h62a1 1 0 0 0 1-1V25h-2zM2 62v-2h60v2zM62 21h2v2h-2zM63 3h-5v2h4v9H2V5h4V3H1a1 1 0 0 0-1 1v46h2V16h60v3h2V4a1 1 0 0 0-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1V5h8v1h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1V5h8v1h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1V5h8v1h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1V2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-8V2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-8V2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-8V2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4H7a1 1 0 0 0-1 1zm49-2a1 1 0 0 0 1-1v2h-6V8a1 1 0 0 0 1 1zm-3-7h2v5h-2zM41 9a1 1 0 0 0 1-1v2h-6V8a1 1 0 0 0 1 1zm-3-7h2v5h-2zM27 9a1 1 0 0 0 1-1v2h-6V8a1 1 0 0 0 1 1zm-3-7h2v5h-2zM10 2h2v5h-2zM8 8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v2H8zM46 19h2v2h-2zM49 19h2v2h-2zM52 19h2v2h-2zM55 19h2v2h-2zM7 19h2v2H7zM10 19h2v2h-2zM7 25h2v2H7zM7 37h2v2H7zM7 42h2v2H7zM7 47h2v2H7zM7 52h2v2H7zM15 25h2v2h-2zM15 32h2v2h-2zM15 37h2v2h-2zM15 42h2v2h-2zM15 47h2v2h-2zM15 52h2v2h-2zM23 25h2v2h-2zM23 32h2v2h-2zM23 37h2v2h-2zM23 42h2v2h-2zM23 47h2v2h-2zM23 52h2v2h-2zM31 25h2v2h-2zM31 32h2v2h-2zM31 37h2v2h-2zM31 42h2v2h-2zM31 47h2v2h-2zM39 25h2v2h-2zM39 32h2v2h-2zM39 37h2v2h-2zM39 42h2v2h-2zM39 47h2v2h-2zM47 25h2v2h-2zM47 32h2v2h-2zM47 37h2v2h-2zM47 42h2v2h-2zM47 47h2v2h-2zM55 25h2v2h-2zM55 32h2v2h-2zM55 37h2v2h-2zM55 42h2v2h-2zM55 47h2v2h-2zM5 31v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1zm2 1h2v2H7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9ac048a01ff40739d91c389b200d454f.svg";
export { ForwardRef as ReactComponent };